module.exports = __webpack_public_path__ + "static/media/Bg-iphone-mobile.48e181f1.png";